import React from "react";

interface Props {
  page: number;
  perPage: number;
  total: number;
  onPageChange: (p: number) => void;
}

const Pagination: React.FC<Props> = ({
  page,
  perPage,
  total,
  onPageChange,
}) => {
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  return (
    <div className="mt-4 flex items-center justify-between">
      <div className="text-sm text-gray-600">
        Page {page} of {totalPages}
      </div>
      <div className="flex items-center space-x-2">
        <button
          className="rounded border px-3 py-1"
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page <= 1}
        >
          Prev
        </button>
        <button
          className="rounded border px-3 py-1"
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          disabled={page >= totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
